import styled from '@emotion/styled'
import {keyframes} from '@emotion/react'
import {COLORS} from '../constants'

/**
 * Skeleton tile grid, laid out with the exact column rules of the live {@link PanelBody} so the
 * placeholder tiles occupy the same footprint as the real ones — when data arrives the tiles swap
 * in with no layout jump (PT-5716).
 */
export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 8px;
`

const shimmer = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.45; }
  100% { opacity: 1; }
`

/** A single placeholder tile: matches a real {@link KpiTile}'s height and gently pulses. */
export const SkeletonTile = styled.div`
  height: 86px;
  border: 1px solid ${COLORS.border};
  border-radius: 8px;
  background-color: ${COLORS.cardBg};
  animation: ${shimmer} 1.4s ease-in-out infinite;
`
